import React, { Component } from 'react';
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import * as moment from 'moment';
import 'moment-timezone';
import PriceFormatter from "../../components/misc/PriceFormatter";
import connect from "react-redux/es/connect/connect";
import { setBusTicket } from "../../redux/actions/ticket";
import { busCompany } from '../../config/busCompany';


class BusItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,

        };
    }

    translateBus(e) {
        let enbus;
        if (busCompany.filter(i => i.fa === e).length !== 0) {
            enbus = busCompany.filter(i => i.fa === e)[0].en
            // console.log(enbus);
            return enbus
        } else {
            return e;
        }
    }

    render() {
        const { item } = this.props;
        // console.log(item.orginTerminal);
        return (
            <Card className="white mb-3 w-100 flight-item">
                <CardBody className={item.availableSeats === 0 ? "pb-0 unavalable-tickets" : "pb-0"}>
                    <Row>
                        <Col md={9}>
                            <Row>
                                <div className='ticket-body bus-ticket'>
                                    <div className='ticket-image'>
                                        <img src={`/assets/images/bus/${item.companyCode}.jpg`} alt={item.companyName}
                                            className='ticket-logo' />

                                        <p className="d-none d-md-block d-lg-block company-title">{this.translateBus(item.companyName)}</p>
                                    </div>
                                    <div className='ticket-from'>
                                        <p><i className='fa fa-map-marker' />
                                            {this.props.orgin}
                                        </p>
                                    </div>
                                    <div className='ticket-arrow'>
                                        <p className='ticket-date'>{item.departureDateTime.substr(0, item.departureDateTime.length - 8)}</p>
                                        <div className="arrow">
                                            <img className='start-piont-img-bus' src='/assets/images/bus.png' alt='small-plane' />
                                            <span className="arrow-width" />
                                            <i className='end-point' ></i>
                                        </div>
                                        <p className='ticket-date bus-time'>{item.departureDateTime.substr(item.departureDateTime.length - 8)}</p>
                                    </div>
                                    <div className='ticket-to'>
                                        <p><i className='fa fa-map-marker' />
                                            {this.props.destination}
                                        </p>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                        <Col md={3} className='text-center ticket-price '>
                            <p className='price'>
                                <PriceFormatter
                                    className="item-price"
                                    data={item.totalPrice}
                                    type="airplane"
                                    date={moment(item.departureDateTime).format("YYYY-MM-DD")}
                                />
                            </p>
                            {item.availableSeats === 0 ?
                                <Button color="info" block active={true} className="book-btn"
                                >Unavailable</Button>
                                :
                                <Button color="info" block active={true} className="book-btn"
                                    onClick={this.handleClick.bind(this)} >Book Ticket</Button>}

                            <p className='available-seat'> {item.availableSeats} Seat is available</p>
                        </Col>
                    </Row>
                    <Row className="d-none d-md-block d-lg-block">
                        <Button color="link" block active={true} className="book-btn more-info-but"
                            onClick={() => this.setState({ showMore: !this.state.showMore })}>
                            More Info <i className={this.state.showMore ? "la la-angle-down" : "la la-angle-up"} />
                        </Button>
                    </Row>
                    {this.state.showMore &&
                        <Row className="d-none d-md-block d-lg-block m-4 mt-0 showMore-content bus-ticket-more">
                            <div className='flight-features'>
                                <div className='bus-ticket-type'><span>Bus Type :</span>
                                    <Badge color="primary">
                                        {item.busType}
                                    </Badge>
                                </div>
                                <div className="more-info-from-div bus-ticket-from">
                                    <span>From :</span>
                                    <p className="d-none d-md-block d-lg-block"><i
                                        className='' /> {item.orginTerminal} </p>
                                </div>
                                <div className="more-info-from-div bus-ticket-to" >
                                    <span>To :</span>
                                    <p className="d-none d-md-block d-lg-block"><i
                                        className='' /> {item.destinationTerminal}  </p>
                                </div>
                            </div>
                        </Row>
                    }
                </CardBody>
            </Card>
        );
    }
    handleClick() {
        const { item } = this.props;

        this.props.setBusTicket(item);
        // this.setState({redirect:true});
        // this.props.history.push('/ticket-passengers');
        window.location.replace("/bus-passengers");

    }

}
const mapDispatchToProps = dispatch => {
    return {
        setBusTicket: (item) => {
            dispatch(setBusTicket(item))
        }
    }
};

export default connect(null, mapDispatchToProps)(BusItem)


// WEBPACK FOOTER //
// ./src/containers/bus/BusItem.jsx